module.exports = __webpack_public_path__ + "img/13.73a67eec.png";